export default [
  {
    path: 'facilities',
    component: () => import('@/views/facilities/FacilitiesList.vue'),
    meta: { 
      title:'Facilities',
      requiresAuth: true,
      requiresAmazon: true,
      permission: 'facility_dashboard',
    },
  },
  {
    path: '/facilities/create',
    component: () => import('@/views/facilities/FacilityForm.vue'),
    meta: { 
      title:'Facilities',
      requiresAuth: true,
      requiresAmazon: true,
      permission: 'create_facility',
    },
  },
  {
    path: '/facilities/edit/:id',
    component: () => import('@/views/facilities/FacilityForm.vue'),
    meta: { 
      title:'Facilities',
      requiresAuth: true ,
      requiresAmazon: true,
      permission: 'edit_facility',
    },
  },
  {
    path: '/facilities/details/:id',
    component: () => import('@/views/facilities/FacilityDetails.vue'),
    meta: { 
      title:'Facilities',
      requiresAuth: true,
      requiresAmazon: true,
      permission: 'edit_facility',
    },
  }
]